export default class MathUtils {
    public limit = {
        B: 1,
        KB: 1024,
        MB: 1024 * 1024,
        GB: 1024 * 1024 * 1024,
    };

    public fixed = (number: any): string => {
        if (number === null || number === undefined || number === "") {
            return "";
        }
        return Number(number).toFixed(2);
    };

    public randomWithinRange = (min: number, max: number): number => {
        return Math.floor(Math.random() * (max - min) + min);
    };

    public getRandomColor = (): string => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    public toInt = (str: string[]) => {
        return str.map((s) => parseInt(s, 10));
    };

    public formatByte = (byte: number) => {
        const { KB, MB, GB } = this.limit;
        let unit = "B";

        if (byte > GB) {
            unit = "GB";
        } else if (byte > MB) {
            unit = "MB";
        } else if (byte > KB) {
            unit = "KB";
        }
        return `${(byte / this.limit[unit]).toFixed(1)} ${unit}`;
    };

    public getUniqueNumber = (prefix: string) => {
        return prefix + Date.now() + (Math.random() * 100000).toFixed();
    };

    public formatMoney = (amount) => {
        if (typeof amount === "number") {
            return amount.toLocaleString();
        }
        return "Invalid Amount";
    };

    public parseNumber = (value) => {
        if (value === "") return NaN;
        const number = Number(value);
        return Number.isInteger(number) ? number : NaN;
    };

    public getPercent = (total, percent) => {
        return Math.round((percent / 100) * total);
    };

    public progressPercent = (total, value) => {
        return Math.round((value / total) * 100);
    };

    public calculateUsd = (amount?: any, rate?: any) => {
        const amt = parseFloat(amount);
        const rt = parseFloat(rate);

        if (!isNaN(amt) && !isNaN(rt) && rt > 0) {
            return Number((amt / rt).toFixed(2));
        }
        return undefined; // keeps field blank if inputs are invalid
    };

    public formatKgToMT(value?: any, fraction: any = null)
    {
        let val = parseFloat(value || 0);
        val = val / 1000;


        if (fraction === null || value === 0) {
            return val;
        }
        return val.toFixed(fraction);
    };

    public formatDecimalToHectare(value?: any, fraction: any = null)
    {
        let val = parseFloat(value || 0);
        val = val * 0.0040485830;

        if (fraction === null || value === 0) {
            return val;
        }
        return val.toFixed(fraction);
    };

    public formatToThreeDecimals(value?: any)
    {
        const val = parseFloat(value || 0);
        return val.toFixed(3);
    };

    public formatToFourDecimalsString(value?: any)
    {
        const val = parseFloat(value || 0);
        return val.toFixed(4);
    };

   public formatToFourDecimals = (num: any): number => {
    let value = Number(num);

    if (isNaN(value)) {
        return 0;
    }

    return parseFloat(value.toFixed(4));
};

    public getHarvestingRatePercentage = (actualLand?: any, harvestedLand?: any) => {
        const actual_land = parseFloat(actualLand);
        const harvested_land = parseFloat(harvestedLand);
        if (actual_land <= 0 || harvested_land <= 0) {
            return 0;
        }

        let harvestingRate = (harvested_land / actual_land) * 100;
        harvestingRate = harvestingRate >= 100 ? 100 : harvestingRate;
        if (harvestingRate >= 100) {
            return 100;
        }

        return harvestingRate.toFixed(2);

    };

}
